import { render, staticRenderFns } from "./publicHall.vue?vue&type=template&id=297c2ac1&scoped=true&"
import script from "./publicHall.vue?vue&type=script&lang=js&"
export * from "./publicHall.vue?vue&type=script&lang=js&"
import style0 from "./publicHall.vue?vue&type=style&index=0&id=297c2ac1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c2ac1",
  null
  
)

export default component.exports